// Destinazione post-login accettata SOLO se è un percorso relativo della
// stessa app ("/qualcosa"). Un valore assoluto ("https://…") o
// protocol-relative ("//host", "/\host") arriverebbe da un link costruito
// da terzi e trasformerebbe il login in un open redirect.
export const safeReturnUrl = (value) => {
  if (typeof value !== "string" || value === "") return null;
  if (!value.startsWith("/")) return null;
  if (value.startsWith("//") || value.startsWith("/\\")) return null;
  return value;
};
